import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface TypewriterProps {
  texts: string[];
}

const TypewriterText: React.FC<TypewriterProps> = ({ texts }) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (texts.length === 0) return;

    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        setIsVisible(true);
      }, 1200);
    }, 5000);

    return () => clearInterval(interval);
  }, [texts.length]);

  return (
    <span 
      className={`text-blue-600 transition-opacity duration-[1200ms] ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {texts[currentTextIndex]}
    </span>
  );
};

const heroTaglines = [
  'Put Your Manchester Business on the Map',
  'Get a Professional Website This Week',
  'Turn Website Visitors into Paying Customers',
  'Grow With Booking, Texting & Ads'
];

const HeroSection: React.FC = () => {

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50 to-white z-0" />
      <div className="absolute top-20 right-20 w-72 h-72 bg-blue-100 rounded-full opacity-20 blur-3xl z-0" />
      <div className="absolute bottom-32 left-20 w-96 h-96 bg-blue-50 rounded-full opacity-30 blur-3xl z-0" />
      
      <div className="container-custom relative z-10 py-20">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-gray-900 leading-tight min-h-[8rem] md:min-h-[7rem]">
            <TypewriterText texts={heroTaglines} />
          </h1>
          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            iModernize helps Manchester NH businesses get online, get found, and get more customers — starting at $79/month with the first month free.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="group px-8 py-4 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl inline-flex items-center justify-center"
            >
              Free Consultation
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/pricing"
              className="px-8 py-4 text-lg font-semibold text-blue-600 bg-white hover:bg-gray-50 border-2 border-blue-600 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
